// removed by extract-text-webpack-plugin
module.exports = {"root":"toggle--root--3flWq5ZM","label":"toggle--label--1KWJYp4G","disabled":"toggle--disabled--2amEJNtm input--disabled--2nurGDq5"};


//////////////////
// WEBPACK FOOTER
// ./components/forms/toggle/styles.css
// module id = ./components/forms/toggle/styles.css
// module chunks = 0